/*
 * @Author: cc
 * @Date: 2019-12-21 21:31:55
 * @LastEditTime: 2022-01-18 17:52:33
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editListPart\editListList\editListList.js
 * @Description:新媒体渠道列表指令
 */
angular.module('editListListModule', []).directive('editListList', [
    'trsHttpService',
    'storageListenerService',
    'messagePublishService',
    'newMediaService',
    'trsspliceString',
    'editingCenterService',
    'editingMediatype',
    '$state',
    'qiehaoService',
    function(trsHttpService, storageListenerService, messagePublishService, newMediaService, trsspliceString, editingCenterService, editingMediatype, $state, qiehaoService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editListPart/editListList/editListList.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.status = {
                        enterKeycode: 13, // 回车键的键码
                        // btnRights: {}, // 按钮权限集合
                        // isEssearch: false
                        hasphoto: false, // 是否是图集稿
                        hasphotoflag: true, // 判断是否人为点击图集切换模式
                    };
                    $scope.childData = {
                        selectedArray: [],
                        items: [],
                        keyWords: '',
                        // account: $state.params.account,
                        filterReviseItem: [], // 排除已修订的稿件
                    };
                    $scope.childStatus = {
                        // 图片数组的string
                        checkString: 'DOC_PICTURELIST',
                        // 图片数组中表示url地址的string
                        picString: 'SRCPICURL',
                        originPicUrl: 'SRCPICURL'
                    };
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 20,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 1,
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    requestData();
                    listenStorage();
                    refreshList();
                }

                // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
                $scope.requestData = function() {
                    requestData();
                };
                
                /**
                 * [refreshList description]刷新列表
                 * @return  {[undefined]}  [return description]
                 */
                function refreshList() {
                    messagePublishService.subscribe(
                        'refresh',
                        function(event, data) {
                            $scope.parentStatus.isEssearch = false;
                            if (data === 'clearArray') {
                                // 如果是清除数组则只清除数组 不需要发送请求
                                $scope.data.selectedArray = [];
                            } else {
                                requestData();
                            }
                        },
                    );
                }

                /**
                 * [listenStorage description]监听本地缓存
                 * @return {[promise]} [description] promise
                 */
                function listenStorage() {
                    storageListenerService.listenNewMedia(
                        function() {
                            $scope.parentStatus.isEssearch = false;
                            requestData();
                            storageListenerService.removeListener($scope.parentStatus.storageName);
                        },
                        $scope,
                        $scope.parentStatus.storageName
                    );
                }

                /**
                 * [requestData description]获取数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function requestData() {
                    var params = {
                        PageSize: $scope.page.PAGESIZE,
                        CurrPage: $scope.page.CURRPAGE,
                        DocType: $scope.params.DocType,
                        OperTimeStart: $scope.childData.fromdate,
                        OperTimeEnd: $scope.childData.untildate,
                        searchKeyWord: '',
                        timeType: 0,
                    };
                    
                    var esparams = $scope.parentStatus.isEssearch ? getESSearchParams() : angular.extend(params, $scope.params);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), esparams, 'get').then(
                        function(data) {
                            if (!$scope.parentStatus.isEssearch) {
                                $scope.childData.keyWords = '';
                            }
                            $scope.data.items = data.DATA;
                            if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                                $scope.status.hasphoto = true;
                            } else {
                                $scope.status.hasphoto = false;
                            }
                            storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,MEDIATYPE,DOCMODIFYSTATUSNAME', 'newMediaPreview');
                            $scope.data.filterReviseItem = data.DATA.filter((item) => item.APPSTATUSNAME !== '待修订');
                            $scope.graphParams.ArticleIds = trsspliceString.spliceString($scope.data.items, $scope.parentStatus.idName, ',');
                            newMediaService.requestGraph($scope.data.items, $scope.graphParams, $scope.parentStatus.idName);
                            newMediaService.getReviseInfo($scope.data.items);
                            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                            $scope.data.selectedArray = [];
                        },
                        function(data) {
                            $scope.childData.isLoadFalse = true;
                        }
                    );
                }

                /**
                 * [getESSearchParams description] 处理ES搜索的参数
                 *
                 * @return  {[type]}  [return description]
                 */
                function getESSearchParams() {
                    var esparams = {
                        serviceid: 'mlf_hybasesearch',
                        methodname: 'queryForNewMediaDoc',
                        mediaType: editingMediatype.qiehao,
                        searchParams: {
                            PAGESIZE: $scope.page.PAGESIZE,
                            PAGEINDEX: $scope.page.CURRPAGE,
                            CHANNELID: $state.params.channelid,
                            status_model: '0', // ：0表示代编
                            searchFields: [
                                {
                                    searchField: '',
                                    keywords: $scope.childData.keyWords,
                                },
                                {
                                    searchField: 'docType',
                                    keywords: $scope.params.DocType || '',
                                },
                                {
                                    searchField: 'timeType',
                                    keywords:
                                        angular.isDefined($scope.childData.fromdate) && $scope.childData.fromdate !== ''
                                            ? $scope.childData.fromdate + ',' + $scope.childData.untildate
                                            : '',
                                },
                                {
                                    searchField: '_sort',
                                    keywords: 'time',
                                },
                            ],
                        }
                    };
                    esparams.searchParams = JSON.stringify(esparams.searchParams);
                    return esparams;
                }

                /**
                 * [selectDoc description]单选
                 * @param   {[obj]}    item      [item description]选中的稿件
                 * @return  {[undefined]}        [return description]
                 */
                $scope.selectDoc = function(item) {
                    if ($scope.data.selectedArray.indexOf(item) < 0) {
                        $scope.data.selectedArray.push(item);
                    } else {
                        $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                    }
                };

                /**
                 * [atlasMode description] 图集模式
                 * @return {[type]} [description]
                 */
                $scope.atlasMode = function() {
                    // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
                    $scope.status.hasphoto = !$scope.status.hasphoto;
                    $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
                };
                
                /**
                 * [requestData description]全选
                 * @return {[type]} [description]
                 */
                $scope.selectAll = function() {
                    $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
                };

                /**
                 * [fullTextSearch description]搜索
                 * @param  {[obj]}    ev    [description]事件对象
                 * @return {[undefined]}    [description]
                 */
                $scope.fullTextSearch = function(ev) {
                    $scope.parentStatus.isEssearch = true;
                    if ((ev && ev.keyCode === $scope.status.enterKeycode) || !ev) {
                        $scope.page.CURRPAGE = 1;
                        requestData();
                    }
                };

                /**
                 * [goToDetail description]图集模式跳转细览页
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.goToDetail = function (item) {
                    var params = {
                        mediatype: 19,
                        metadataid: item.KUAIBAOARTICLEID,
                        isawaitrevise: item.DOCMODIFYSTATUSNAME
                    };
                    var url = $state.href('newMediaPreview', params);
                    window.open(url);
                };
                
                /**
                 * [pageChanged description]翻页
                 * @return  {[type]}  [return description]
                 */
                $scope.pageChanged = function() {
                    requestData();
                };

                /**
                 * [jumpToPage description]跳页
                 * @return  {[type]}  [return description]
                 */
                $scope.jumpToPage = function() {
                    $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
                    $scope.loadingPromise = requestData();
                };

                /**
                 * [outSending description]按照时间搜索
                 * @param  {[type]} type [description] 搜索类型
                 * @param  {[type]} val [description] 过滤条件的值
                 * @return  {[type]}  [return description]
                 */
                $scope.queryByDropdown = function(type, val) {
                    if (type === 'DocType') {
                        $scope.params.DocType = val;
                    }
                    if (type === 'DocType' && val === '2') {
                        $scope.status.hasphotoflag = true;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                };

                /**
                 * [qiehaoEditor description] 编辑百家号
                 * @param   {[type]}  docType    [docType description] 稿件类型
                 * @param   {[type]}  account    [account description] 账号id
                 * @param   {[type]}  articleid  [articleid description] 稿件id
                 * @return  {[type]}             [return description]
                 */
                $scope.typeEditor = function(docType, account, articleid) {
                    // var routerName = `#/${
                    //     $scope.parentStatus.editPath[docType]
                    // }?qiehaoaccount=${account}&qiehaoarticleid=${articleid}&qiehaoplatform=${0}`;
                    // window.open(routerName);
                    qiehaoService.qiehaoEditor(docType, account, articleid, 0);
                };

                /**
                 * [processRecord description] 获取企鹅号流程记录
                 * @param   {[type]}  item  [item description] 选中的企鹅号稿件
                 * @return  {[type]}        [return description]
                 */
                $scope.processRecord = function(item) {
                    editingCenterService.getVersionTime(item, false);
                };
            },
        };
    },
]);
